import { makeStyles } from '@material-ui/core';

const useNavButtonStyles = makeStyles((theme) => ({

  bottomToolbar: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexGrow: 1,
  },

  submitBtn: {
    backgroundColor: 'var(--teal-blue)',
    fontFamily: 'var(--font-family-bold)',
    '&:hover': {
      backgroundColor: 'var(--teal-blue)'
    },
    height: '30px',
    lineHeight: 1,
    borderRadius: '4px',
    color: 'var(--white)',
    border: '2px solid var(--teal-blue)',
    fontSize: 'var(--button-text-size)',
    minWidth: '150px',
    '&:disabled': {
      backgroundColor: 'var(--disabled)',
      border: '1px solid var(--disabled)',
      color: 'var(--neutrals-black)'
    }
  },

  defaultBtn: {
    border: '2px solid var(--teal-blue)',
    backgroundColor: 'var(--white)',
    color: 'var(--teal-blue)',
    fontFamily: 'var(--font-family-bold)',
    height: '30px',
    lineHeight: 1,
    borderRadius: '4px',
    fontSize: 'var(--button-text-size)',
    minWidth: '150px'
  }

}));

export default useNavButtonStyles;